export const COUPON_STATUS = {
     AVAILABLE: 'available',
     USED: 'used',
     EXPIRED: 'expired',
};

export const COUPON_TYPE = {
     DISCOUNT_AMOUNT_IN_TOTAL: 'DISCOUNT_AMOUNT_IN_TOTAL',
     DISCOUNT_AMOUNT_IN_CART: 'DISCOUNT_AMOUNT_IN_CART',
};

export const COUPON_TYPE_LABEL = {
     DISCOUNT_AMOUNT_IN_TOTAL: 'Discount On Product',
     DISCOUNT_AMOUNT_IN_CART: 'Discount On Cart',
};

export const DISCOUNT_TYPE = {
     PERCENT: 'percent',
     PRICE: 'price',
};
